import React from 'react';
import PresenterMobileSideStrips from './presenter-mobile-side-strips/presenter-mobile-side-strips';
import Tab from '../shared/tabs-container/tab/tab';
import PresenterSlideThumbnails from './presenter-slide-thumbnails/presenter-slide-thumbnails';
import { PresenterTabsOnMobile } from '../../constans/presenter-enums';
import PresenterSlideCarousel from './presenter-slide-carousel/presenter-slide-carousel';
import PresenterMobileNavigation from './presenter-mobile-navigation/presenter-mobile-navigation';
import { observer } from 'mobx-react';

interface IProps {
    mobileSelectTab: PresenterTabsOnMobile;
    isMobile: boolean;
    isClickerMobileTab: boolean;
    isSelected: (tabName: PresenterTabsOnMobile | PresenterTabsOnMobile[]) => boolean;
    setMobileSelectTab: (selectedTab: PresenterTabsOnMobile) => void;
}

const PresenterSlideWrapper =
    ({
      mobileSelectTab,
      isMobile,
      isClickerMobileTab,
      isSelected,
      setMobileSelectTab,
    }: IProps): JSX.Element => {

      return (
        <>
          <PresenterMobileSideStrips currentTab={mobileSelectTab}/>
          <Tab isSelected={!isMobile}>
            <PresenterSlideThumbnails/>
          </Tab>
          <Tab isSelected={isSelected([PresenterTabsOnMobile.CLICKER, PresenterTabsOnMobile.NOTES])}>
            <PresenterSlideCarousel isClickerMobileTab={isClickerMobileTab}/>
          </Tab>
          <PresenterMobileNavigation
            setSelectedTab={setMobileSelectTab}
            selectedTab={mobileSelectTab}
          />
        </>);
    };


export default observer(PresenterSlideWrapper);
